/**
 * Hľadanie v prehliadači — to isté pravidlo ako na serveri
 * (`services/search_normalize`, `_search_podmienky`): bez diakritiky, bez
 * veľkých písmen a **všetky slová v ľubovoľnom poradí**. Do KOLA 201 boli
 * tri kópie `normalize("NFD")…` (Cenník, operácie, odkaz Häfele) a každý
 * výber hľadal trochu inak.
 */

/** „Drážka" → „drazka", „Häfele" → „hafele". */
export function bezDiakritiky(text: string): string {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

/**
 * Sedia všetky slová hľadania? „dub 22" nájde „ABS dub gravír 22x1mm".
 * Prázdne hľadanie sedí vždy.
 */
export function sediaSlova(
  hladane: string,
  texty: readonly (string | null | undefined)[],
): boolean {
  const slova = bezDiakritiky(hladane).split(/\s+/).filter(Boolean);
  if (slova.length === 0) return true;
  const kopa = bezDiakritiky(texty.filter(Boolean).join(" "));
  return slova.every((s) => kopa.includes(s));
}
